import script from "./PassengersForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PassengersForm.vue?vue&type=script&setup=true&lang=ts"

import "./PassengersForm.vue?vue&type=style&index=0&id=493d14e5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-493d14e5"]])

export default __exports__